/**
 * The skip link (TMMAPP-0072, TMM-B7 / A11Y): the first focusable element in the shell. Visually
 * hidden until it has focus; activating it moves focus to `<main id="main" tabIndex={-1}>` (the
 * click is handled in place — a hash link would push a history entry and fight the router).
 */
import { Box, useTheme } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { useTranslation } from 'react-i18next';
import { resolveTokens } from '@/theme/theme';

export const MAIN_ID = 'main';

export function SkipLink() {
  const { t } = useTranslation();
  const theme = useTheme();
  const tokens = resolveTokens(theme);
  return (
    <Box
      component="a"
      href={`#${MAIN_ID}`}
      onClick={(event: React.MouseEvent) => {
        event.preventDefault();
        document.getElementById(MAIN_ID)?.focus();
      }}
      sx={{
        '&:not(:focus)': visuallyHidden,
        '&:focus': {
          position: 'fixed',
          insetBlockStart: 8,
          insetInlineStart: 8,
          zIndex: theme.zIndex.tooltip + 1,
          paddingBlock: 1,
          paddingInline: 2,
          bgcolor: tokens.surface,
          color: tokens.text,
          border: `2px solid ${tokens.brandBoundary}`,
          borderRadius: `${tokens.radius.control}px`,
          ...theme.typography.body2,
          fontWeight: 500,
          textDecoration: 'none',
        },
      }}
    >
      {t('shell.skipToContent')}
    </Box>
  );
}
